import { render, staticRenderFns } from "./LicenseDetails.vue?vue&type=template&id=9255f4fa&scoped=true"
import script from "./LicenseDetails.vue?vue&type=script&lang=js"
export * from "./LicenseDetails.vue?vue&type=script&lang=js"
import style0 from "./LicenseDetails.vue?vue&type=style&index=0&id=9255f4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9255f4fa",
  null
  
)

export default component.exports